import { GET_ERRORS, PERSONAL_INFO_FETCH } from "./types";
import axios from "axios";
import { API_CANDIDATE } from "../../utils/config";
import { setMessage } from "./common/setMessageAction";

export const updateProfilePic = (data) => (dispatch) => {
  axios
    .put(
      `${API_CANDIDATE}/v1/api/create-user/profile`,
      data,
      { withCredentials: true },
      {
        headers: {
          "Content-Type": "multipart/form-data; ",
        },
      }
    )
    .then((res) => {
      console.log(res);
      dispatch(setMessage(res.data));
      dispatch(getProfileInfo());
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data,
        });
        setTimeout(() => {
          dispatch({
            type: GET_ERRORS,
            payload: null,
          });
        }, 2000);
      } else {
        dispatch({
          type: GET_ERRORS,
          payload: err.message,
        });
        setTimeout(() => {
          dispatch({
            type: GET_ERRORS,
            payload: null,
          });
        }, 2000);
      }
    });
};

export const getProfileInfo = () => (dispatch) => {
  axios
    .get(`${API_CANDIDATE}/v1/api/create-user`, { withCredentials: true })
    .then((res) => {
      console.log(res);
      dispatch({
        type: PERSONAL_INFO_FETCH,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log("err", err);
    });
};
